import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import EmbedBooking from "./components/embed/EmbedBooking";
import SitePreviewFrame from "./components/site-preview/SitePreviewFrame";
import { parseEmbedLocation } from "./utils/embed";
import { isSitePreviewPath } from "./utils/sitePreview";
import i18n from "./utils/i18n";
import { installLocalizedValidation } from "./utils/formValidation";
import { dropServerCanonical } from "./hooks/usePageMeta";

// The browser's "Please fill out this field." bubbles, in the page's language
// rather than the browser's — for every form, the widget included.
installLocalizedValidation(i18n);

// The booking widget renders on its own, not as a route inside <App>: App reads
// the session from localStorage on its first render, and a browser blocking
// third-party storage throws on that read inside someone else's site. See
// utils/embed.js.
const embed = parseEmbedLocation(window.location);

// The live preview Site & widget and the setup wizard frame: also on its own,
// because it needs no session and no routes — only the draft the dashboard
// posts to it. See utils/sitePreview.js.
const sitePreview = isSitePreviewPath(window.location.pathname);

// A prerendered page (scripts/prerender.mjs) or a business's page the API wrote
// arrives with a canonical already in <head>; usePageMeta writes its own.
dropServerCanonical();

// createRoot, not hydrateRoot: the markup such a page arrives with is the
// anonymous, Romanian first paint, and React replaces it rather than adopting
// it — a signed-in or English-reading visitor would otherwise be a hydration
// mismatch on every load.
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {embed ? (
      <EmbedBooking {...embed} />
    ) : sitePreview ? (
      <SitePreviewFrame />
    ) : (
      <App />
    )}
  </React.StrictMode>,
);
